import axios from 'axios';
import { socket } from '../socket';
import * as actionTypes from './types';

export const retrievePersonas = (journeyId) => {
  return (dispatch) => {
    axios
      .get('/api/persona/journey_id/' + journeyId)
      .then((res) => {
        for (var key in res.data.persona) {
          var persona = res.data.persona[key];

          dispatch(
            addPersona(
              persona.id,
              persona.name,
              persona.role,
              persona.hero,
              persona.pic_url,
            )
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const addPersonaDB = (
  journeyId,
  name,
  role,
  hero,
  picUrl,
) => {
  return (dispatch) => {
    axios
      .post('/api/persona', {
        journey_id: journeyId,
        name: name,
        role: role,
        hero: hero,
        pic_url: picUrl,
      })
      .then((result) => {
        dispatch(
          addPersona(
            result.data.saved.id,
            result.data.saved.name,
            result.data.saved.role,
            result.data.saved.hero,
            result.data.saved.pic_url,
          )
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const addPersonaDBOnly = (journeyId, name, role, hero, picUrl) => {
  return () => {
    socket.emit('onPersonaAddServer', { 
      journeyId : journeyId, 
      name : name, 
      role : role, 
      hero : hero, 
      picUrl : picUrl});
  };
};

export const addPersona = (
  id,
  name,
  role,
  hero,
  picUrl,
) => ({
  type: actionTypes.ADD_PERSONA,
  id: id,
  name: name,
  role: role,
  hero: hero,
  picUrl: picUrl,
});

export const editPersonaDB = (
  journeyId,
  id,
  name,
  role,
  hero,
  picUrl,
) => {
  return (dispatch) => {
    console.log(picUrl)
    axios
      .put('/api/persona/id/' + id, {
        id: id,
        journey_id: journeyId,
        name: name,
        role: role,
        hero: hero,
        pic_url: picUrl,
      })
      .then((result) => {
        dispatch(
          editPersona(
            result.data.saved.id,
            result.data.saved.name,
            result.data.saved.role,
            result.data.saved.hero,
            result.data.saved.pic_url,
          )
        );
      });
  };
};

export const editPersonaDBOnly = (journeyId, id, name, role, hero, picUrl) => {
  return () => {
    socket.emit('onPersonaUpdateServer', { 
      journeyId : journeyId, 
      personaId : id,
      name : name, 
      role : role, 
      hero : hero, 
      picUrl : picUrl});  
  };
};

export const editPersona = (
  id,
  name,
  role,
  hero,
  picUrl,
) => ({
  type: actionTypes.EDIT_PERSONA,
  id: id,
  name: name,
  role: role,
  hero: hero,
  picUrl: picUrl,
});

export const deletePersonaDB = (id) => {
  return (dispatch) => {
    axios
      .delete('/api/persona/id/' + id)
      .then((result) => {
        dispatch(deletePersona(id));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const deleteJourneyPersonas = (journeyId) => {
  return (dispatch) => {
    axios
      .delete('/api/persona/journey_id/' + journeyId)
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const deletePersonaDBOnly = (id) => {
  return () => {
    socket.emit('onPersonaDeleteServer', id);
  }
};

export const deletePersona = (id) => ({
  type: actionTypes.DELETE_PERSONA,
  id: id,
});
